import { render, staticRenderFns } from "./WaitApprovalDetail.vue?vue&type=template&id=e1088c4a&"
import script from "./WaitApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./WaitApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitApprovalDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports